import { FilterAppliedProps } from './types';
import { MdClose } from 'react-icons/md';

// cantidad de pills visibles antes de mostrar el botón "..."
const MAX_VISIBLE_PILLS = 5;

const pillClassName = 'px-3 py-1 rounded-xsm bg-brand-green-5 text-brand-green-20 text-bsmall';

const FilterApplied = ({ groups, toogleConfigModal, onRemove, disabledRemove }: FilterAppliedProps) => {
    const pills = groups.flatMap(group =>
        group.values.map(value => ({ id: `${group.key}-${value}`, key: group.key, value }))
    );
    const hasMore = pills.length > MAX_VISIBLE_PILLS;
    const visiblePills = !hasMore ? pills : pills.slice(0, MAX_VISIBLE_PILLS);

    return (
        <>
            <p className="text-tmedium text-primary-10">Filtros aplicados</p>
            {
                pills.length > 0 ? (
                    <div className='flex flex-wrap gap-2 mt-3'>
                        {visiblePills.map(pill => (
                            <span key={pill.id} className={`${pillClassName} flex items-center gap-1`}>
                                {pill.value}
                                <button
                                    type='button'
                                    onClick={() => onRemove(pill.key, pill.value)}
                                    disabled={disabledRemove}
                                    aria-label={`Quitar filtro ${pill.value}`}
                                    className='disabled:opacity-50'
                                >
                                    <MdClose size={14} />
                                </button>
                            </span>
                        ))}
                        {hasMore && (
                            <button
                                type='button'
                                className={pillClassName}
                                onClick={toogleConfigModal}
                                title={`Ver ${pills.length - MAX_VISIBLE_PILLS} más`}
                            >
                                ...
                            </button>
                        )}
                    </div>
                ) : (
                    <p className="text-blarge text-system-light-40 mt-3">No hay filtros seleccionados</p>
                )
            }
        </>
    )
}

export default FilterApplied